module.exports = __webpack_public_path__ + "img/preset1.3cc416ea.png";